<app-stages [stages]="stages" currentStage="Załączniki">
</app-stages>
<br>
@if (!pending() && !loading()) {
  @if (mapContentUrl; as url) {
    <app-execution-of-traffic-organization-projects-map
      (close)="mapContentUrl = null"
      [mapContentUrl]="url">
    </app-execution-of-traffic-organization-projects-map>
  }
  @if (application()?.service?.url; as url) {
    <app-attachments-data-alerts
      [application]="application()"
      [feeCategory]="feeCategory()">
    </app-attachments-data-alerts>
  }
  <div class='row'>
    <div class='col-12'>
      <form novalidate autocomplete='off' [formGroup]='form' (ngSubmit)='submitAndGoNext()'>
        <ol>
          @for (item of attachmentsPositions(); track item.tag) {
            <li>
              <div class='row'>
                <div class='col-md-7'>
                  <p>
                    @if (item.required) {
                      *
                    } {{ item.description }}
                  </p>
                  @if ((item.description === 'Projekt organizacji ruchu') && !!application()?.porAssignmentApplication) {
                    @if (application()?.porAssignmentApplication | application | async; as app) {
                      @if (app?.description; as url) {
                        <br>
                        <app-alert [closable]="false" type="info">
                          Otwórz wybrany projekt i wygeneruj wydruk, który należy tu dołączyć:
                          <a href="#" role="button" class="btn btn-tertiary icon-btn"
                             (click)="$event.preventDefault(); mapContentUrl = url">
                            <i aria-hidden="true" class='fa fa-file-alt'></i>
                            Otwórz
                          </a>
                        </app-alert>
                      }
                    }
                  }
                </div>
                <div class='col-md-5'>
                  @if (form.getFormControlByName(item.tag); as control) {
                    <app-file-uploader
                      (pending)="handleUploading($event)"
                      [customName]="item.description"
                      [tagName]='item.tag'
                      [formControl]='control'
                      [multiple]="item.multiple">
                    </app-file-uploader>
                  }
                </div>
              </div>
            </li>
            @if (!$last) {
              <br>
            }
          }
        </ol>
        <br>
        <div class='application-actions'>
          <button
            type='button'
            class='btn btn-secondary'
            [routerLink]='cancelUrl'>
            <span>
              Wstecz
            </span>
          </button>
          <button
            [disabled]="pending() || uploading()"
            (click)='submitAndGoNext()'
            type='button'
            class='btn btn-primary'>
            <span>Zatwierdź i przejdź do podpisania</span>
          </button>
        </div>
      </form>
    </div>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
